import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Layout from 'Components/Layout';
import ReturnButton from 'Components/ReturnButton';
import Revisions from 'Components/revisions';
import RevisionNote from 'Components/revisions/Note';
import TabsRoute from 'Components/TabsRoute';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { getItemBySlug } from 'Services/connectors';
import { getDefaultPeoplePath, getPersonUsualName } from '../../utils';
import { fetchReferee, updateReferee } from '../actions';
import Form from './Form';
import { SimpleBreadcrumbs } from '../../../../common/components/SimpleBreadcrumbs';

@injectIntl
@connect((store, props) => ({
  slug: props.match.params.topicSlug,
  referee: getItemBySlug(store.referee, props.match.params.topicSlug),
  fetching: store.referee.fetching,
}))
export default class RefereeDetail extends Component {
  state = {
    showRevisions: false,
  };
  menu = [{ label: 'app_personInfo', link: '/' }];

  componentDidMount() {
    this.fetchData();
  }
  UNSAFE_componentWillReceiveProps(next) {
    if (next.slug != this.props.slug) {
      this.fetchData(next.slug);
    }
  }

  fetchData = targetSlug => {
    const { slug, dispatch } = this.props;
    dispatch(fetchReferee(targetSlug || slug));
  };

  toggleRevisions = () => {
    const { showRevisions } = this.state;
    this.setState({ showRevisions: !showRevisions });
  };

  handleRefereeChange = person => {
    const { dispatch } = this.props;
    return dispatch(updateReferee(person.id, person));
  };

  getLabel = () => {
    const { referee } = this.props;
    return getPersonUsualName(referee);
  };

  render() {
    const {
      fetching,
      referee,
      match,
      history,
      intl: { messages: m },
    } = this.props;

    if (fetching) {
      return <CircularProgress size={100} style={{ width: 100, margin: 'auto' }} />;
    }
    if (!referee) {
      return <div>{m.error_noData}</div>;
    }

    return (
      <Layout
        id="referee-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[
              {
                labelKey: 'app_referees',
                href: `#${getDefaultPeoplePath('referees')}`,
              },
              { label: this.getLabel() },
            ]}
          />
        }
        main={
          <div>
            <Paper elevation={2}>
              <Toolbar>
                <Typography variant="h6">{this.getLabel()}</Typography>
                <div style={{ flex: 1 }} />
                <ReturnButton entity="referees" />
              </Toolbar>

              <TabsRoute match={match} menu={this.menu} history={history} />

              <Route
                exact
                path={match.url}
                render={() => (
                  <div>
                    <div>
                      <RevisionNote
                        style={{ margin: 16 }}
                        createdAt={referee.createdAt}
                        updatedAt={referee.updatedAt}
                        toggle={this.toggleRevisions}
                      />
                      {this.state.showRevisions && (
                        <Revisions
                          entity="person"
                          id={referee.id}
                          updatedAt={referee.updatedAt}
                          onRollback={() => this.fetchData()}
                        />
                      )}
                    </div>
                    <Form onSubmit={this.handleRefereeChange} data={referee} />
                  </div>
                )}
              />
            </Paper>
          </div>
        }
      />
    );
  }
}
